module.exports = __webpack_public_path__ + "static/media/bg-landing.06a3d843.png";